// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoBold_68833e', '__robotoBold_Fallback_68833e'","fontWeight":700},"className":"__className_68833e","variable":"__variable_68833e"};